import { Card, CardBody } from "@windmill/react-ui";
import LabelArea from "components/form/LabelArea";
import InputAreaPrice from "components/form/InputAreaPrice";
import QuillEditor from "components/form/QuillEditor";
import Error from "components/form/Error";
import PageTitle from "components/Typography/PageTitle";
import { Button } from "@windmill/react-ui";
import useCancellationPolicyHourRentalSubmit from "hooks/useCancellationPolicyHourRentalSubmit";
import sidebar from "routes/sidebar";
const CancellationPolicyHourRental = () => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    setInclusion,
    setExclusion,
    inclusion,
    exclusion,
    cancelPolicy,
    setTermsCondition,
    setCancelPolicy,
    termsCondition,
  } = useCancellationPolicyHourRentalSubmit(1);

  return (
    <>
      <PageTitle sidebar={sidebar().sidebar} />

      <Card className="flex-grow w-full max-h-full">
        <CardBody>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <LabelArea label="Tax (%)" />
                <div className="col-span-8 sm:col-span-4">
                  <InputAreaPrice
                    trigger={trigger}
                    register={register}
                    maxLength={2}
                    label="Tax"
                    name="tax"
                    type="text"
                    placeholder=""
                  />
                  <Error errorName={errors.tax} />
                </div>
              </div>
              {/* <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <LabelArea label="TDS (%)" />
                  <div className="col-span-8 sm:col-span-4">
                    <InputAreaPrice
                      trigger={trigger}
                      register={register}
                      label="TDS"
                      maxLength={2}
                      name="tds"
                      type="text"
                      placeholder=""
                     
                    />
                    <Error errorName={errors.tds} />
                  </div>
                </div> */}
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <LabelArea label="Inclusion" />
                <div className="col-span-8 sm:col-span-4">
                  <QuillEditor
                    value={inclusion}
                    onChangeFunction={(newContent) => setInclusion(newContent)}
                    register={register}
                    label="Inclusion"
                    name="inclusion"
                  />
                  <Error errorName={errors.inclusion} />
                </div>
              </div>
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <LabelArea label="Exclusion" />
                <div className="col-span-8 sm:col-span-4">
                  <QuillEditor
                    value={exclusion}
                    onChangeFunction={(newContent) => setExclusion(newContent)}
                    register={register}
                    label="Exclusion"
                    name="exclusion"
                  />
                  <Error errorName={errors.exclusion} />
                </div>
              </div>
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <LabelArea label="Terms And Condition" />
                <div className="col-span-8 sm:col-span-4">
                  <QuillEditor
                    value={termsCondition}
                    onChangeFunction={(newContent) =>
                      setTermsCondition(newContent)
                    }
                    register={register}
                    label="Terms And Condition"
                    name="terms_condition"
                  />
                  <Error errorName={errors.terms_condition} />
                </div>
              </div>
              <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                <LabelArea label="Cancellation Policy" />
                <div className="col-span-8 sm:col-span-4">
                  <QuillEditor
                    value={cancelPolicy}
                    onChangeFunction={(newContent) =>
                      setCancelPolicy(newContent)
                    }
                    register={register}
                    label="Cancellation Policy"
                    name="cancel_policy"
                  />
                  <Error errorName={errors.cancel_policy} />
                </div>
              </div>
            </div>

            <div
              className="fixed z-10 bottom-0 py-6 justify-center flex bg-gray-50  border-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
              style={{ width: "75%" }}
            >
              <Button type="submit" className="w-1/5 h-10">
                <span>Update</span>
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </>
  );
};

export default CancellationPolicyHourRental;
